import { formatDate } from "@fullcalendar/react";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";

export default function EventEditForm({
  event,
  setEvent,
  showParticipants,
  calendar,
}) {
  return (
    <div className="calendar-app-sidebar-section event-edit-form">
      <button
        type="button"
        className="btn btn-outline-danger border-0 float-end"
        onClick={() => {
          event.remove();
          setEvent(null);
        }}
      >
        <FontAwesomeIcon icon={faMinusCircle} />
      </button>
      <h3>Event Details </h3>
      <div className="mb-3">
        All Day: {event.allDay ? "Yes" : "No"} <br />
        Start:{" "}
        {formatDate(event.start, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}{" "}
        <br />
        End:{" "}
        {formatDate(event.end, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}
        <br />
        {calendar.capacity_per_event && (
          <div>Default capacity: {calendar.capacity_per_event}</div>
        )}
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={showParticipants}
        >
          Participants ({8})
        </button>
      </div>
      <div className="mb-3">
        <label className="form-label">Label </label>

        <input
          type="text"
          className="form-control"
          placeholder="Slot Label"
          value={event?.title}
          onChange={(e) => event?.setProp("title", e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Description </label>

        <textarea
          type="number"
          className="form-control"
          placeholder="Response"
          value={event?.extendedProps.description}
          onChange={(e) =>
            event?.setExtendedProp("description", e.target.value)
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Capacity </label>

        <input
          type="number"
          className="form-control"
          placeholder="Capacity"
          value={event?.extendedProps.capacity}
          onChange={(e) => event?.setExtendedProp("capacity", e.target.value)}
        />
      </div>
    </div>
  );
}
